var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 113.65,
    y1: 291.59,
    x2: 460.49,
    y2: 158.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0070fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 69.96,
    y1: 177.78,
    x2: 416.81,
    y2: 44.65,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.62,192.27,423.89,96a8.87,8.87,0,0,0,2.58-7h0a8.91,8.91,0,0,0-8.88-8.22H343.4a46.28,46.28,0,0,0-32.73,13.56l-75.29,75.29A56,56,0,0,1,194.81,186l-71.19-1.21a8.92,8.92,0,0,0-6.45,2.61L76.11,228.49a8.92,8.92,0,0,0-2.61,6.3v1a8.91,8.91,0,0,0,8.91,8.91h91.73a8.87,8.87,0,0,0,6.55-2.88l32.75-35.6a8.91,8.91,0,0,1,12.86-.27l83.26,83.26a41,41,0,0,0,29,12h76.37a8.91,8.91,0,0,0,8.88-8.22h0a8.87,8.87,0,0,0-2.58-7l-93.62-93.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.27,106.07H163.82a24,24,0,0,0-16.95,7l-36.5,36.5a9.59,9.59,0,0,0-2.82,6.8v2.94a5.58,5.58,0,0,0,5.58,5.59h81.31a34.45,34.45,0,0,0,24.14-9.87l34.06-33.41A9.09,9.09,0,0,0,246.27,106.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c8869e2c62f4cb31ede4bf91ea9dd323.svg";
export { ForwardRef as ReactComponent };